export default __webpack_public_path__ + "static/media/ita.f85ecaa2.gif";